import { Outlet } from "react-router-dom";
import AsideMenu from "./AsideMenu.jsx";
import NavBar from "./NavBar.jsx";
import FooterBar from "./FooterBar.jsx";
import { LayoutProvider } from "../../context/LayoutContext.jsx";

export default function LayoutAuthenticated() {
  return (
    <LayoutProvider>
      {/* h-screen + overflow-hidden constrains the viewport so flex children can use h-full */}
      <div className="h-screen overflow-hidden bg-[#f0f2f5] dark:bg-[#0b141a] flex-1">
        <AsideMenu />
        <NavBar />

        {/* Content column: full height minus the fixed navbar */}
        <div className="pt-14 h-full flex flex-col">
          {/* overflow-y-auto: normal pages scroll; CasesView contains its own overflow via .main-layout */}
          <main className="flex-1 min-h-0 overflow-y-auto bg-[#f0f2f5] dark:bg-[#0b141a] flex flex-col">
            <Outlet />
          </main>
          <FooterBar />
        </div>
      </div>
    </LayoutProvider>
  );
}
